import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Slices from '../views/Slices.vue'
import home from '../views/Home.vue'
import TalentPool from '../views/TalentPool.vue'
import TaskList from '../views/TaskList.vue'
import TaskDetail from '../views/TaskDetail.vue'
import TalentPoolDetail from '../views/TalentPoolDetail.vue'
import PublishTask from '../views/PublishTask.vue'
import ProfileCenter from '../views/ProfileCenter.vue'
import register from '../views/auth/Register.vue'
const Jobs = { template: '<div style="padding:24px;">找工作（占位）</div>' }
const routes = [
  { path: '/', redirect: '/login' },
  { path: '/slices', name: 'Slices', component: Slices },
  { path: '/login', name: 'Login', component: Login },
  { path: '/home', name: 'home', component: home },
  { path: '/jobs', component: Jobs },
  { path: '/register', name: 'register', component: register },
  { path: '/talent', name: 'TalentPool', component: TalentPool },
  { path: '/tasksDetail',name: 'TaskDetail', component: TaskDetail },
  { path: '/talentPoolDetail',name: 'TalentPoolDetail', component: TalentPoolDetail },
  { path: '/tasks',  name: 'TaskList',component: TaskList , props: true },
  { path: '/publish-task', name: 'PublishTask', component: PublishTask },
  { path: '/profile', name: 'ProfileCenter', component: ProfileCenter },
  {
    path: '/forgot',
    component: () => import('@/views/auth/forgot/AuthShell.vue'),
    children: [
      { path: '', component: () => import('@/views/auth/forgot/StepAccount.vue') },
      { path: 'verify', component: () => import('@/views/auth/forgot/StepVerify.vue') },
      { path: 'reset', component: () => import('@/views/auth/forgot/StepReset.vue') },
      { path: 'success', component: () => import('@/views/auth/forgot/StepSuccess.vue') },
    ],
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// const whiteList = ['/login', '/register', '/forgot', '/forgot/verify', '/forgot/reset', '/forgot/success']

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token')

//   if (!token && !whiteList.includes(to.path)) {
//     next('/login')
//   } else if (token && to.path === '/login') {
//     next('/home')
//   } else {
//     next()
//   }
// })

export default router

